export const authCheckQrCodeUrl = process.env.NODE_ENV == 'production' ? 'yanhao.vv-tool.com' : 'test-yanhao.vv-tool.com'

export const dyCheckInfo = {
    sex: {
        1: '未知',
        2: '男性',
        3: '女性'
    },
    e_account_role: {
        i: '个人',
        m: '普通服务号',
        s: '企业服务号',
        k: '品牌服务'
    },
    qrStatus: {
        1: '待扫码',
        2: '扫码成功',
        3: '二维码过期',
    }
}
